/*
 * @Description: Vue 入口文件
 * @Author: Pancras
 * @Date: 2022-06-27 12:00:56
 * @LastEditors: Adlj
 * @LastEditTime: 2022-10-13 17:55:41
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element UI
import ElementUI from 'element-ui'
import './element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
// 工具类
import '@/libs/util.js'
// Flex 布局
import 'flex.css'
// 重置 CSS 样式
// import 'normalize.css'

// 按钮权限控制
import '@/libs/btn-permissions.js'

// dayjs插件
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart, PieChart, RadarChart, CandlestickChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  ToolboxComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

import 'lib-flexible/flexible'
import plugins from './plugins' // plugins
import filters from '@/libs/filters' // 工具类
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from '@/utils/ruoyi'
import { getDicts } from '@/api/system/dict/data'
// 字典数据组件
import DictData from '@/components/DictData'
// 文件上传组件
import FileUpload from '@/components/FileUpload'
// 图片上传组件
import ImageUpload from '@/components/ImageUpload'
// 图片预览组件
import ImagePreview from '@/components/ImagePreview'
// 分页组件
import Pagination from '@/components/Pagination'
// 字典标签组件
import DictTag from '@/components/DictTag'
// 区划选择
import AreaSelect from '@/components/AreaSelect'

import AreaSelect2 from '@/components/AreaSelect2'
// 引用公共 filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
  PieChart,
  ToolboxComponent,
  RadarChart,
  CandlestickChart
])

dayjs.extend(RelativeTime)

Vue.prototype.$echarts = echarts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.getDicts = getDicts
Vue.component('DictTag', DictTag)
Vue.component('Pagination', Pagination)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('AreaSelect', AreaSelect)
Vue.component('AreaSelect2', AreaSelect2)
Vue.use(plugins)
DictData.install()
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
